module.exports = __webpack_public_path__ + "static/media/AboutUsSuccessStory3.79f1fb00.webp";